export default __webpack_public_path__ + "static/media/product.c048aac4.png";